import { useQueryParams } from "@certn/api";
import { AuthOutlet, SessionTimeoutMonitor } from "@certn/auth";
import { Loader } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router";

import { AppRoutes } from "./AppRoutes";
import { ProfileProvider } from "../auth/ProfileProvider";
import { ApplicantMessagesProvider } from "../components/ApplicantMessagesProvider";
import { useRecordInviteOpened } from "../hooks/useRecordInviteOpened";
import { Application } from "../pages/application";
import { ApplicationSubmitted } from "../pages/application/ApplicationSubmitted";
import { DCOReviewDecisionPage } from "../pages/dco-review/DCOReviewDecisionPage";
import { InformationRequestPage } from "../pages/information-request/InformationRequestPage";
import { MonitoringClientDetailPage } from "../pages/monitoring/MonitoringClientDetailPage";
import { ReportPage } from "../pages/report";

export function ProtectedRoutes() {
  const { t } = useTranslation();
  const { params } = useQueryParams();
  const inviteOpenedReady = useRecordInviteOpened();

  const email = Array.isArray(params.email) ? params.email[0] : params.email;
  const hasApplicantAccount = params.has_account === "True";

  if (!inviteOpenedReady) {
    return (
      <div
        className={css({
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        })}
      >
        <Loader />
      </div>
    );
  }

  return (
    <AuthOutlet
      subtitle={t(
        "Authenticate your account by logging in with Certn's SSO provider."
      )}
      email={email}
      hasApplicantAccount={hasApplicantAccount}
    >
      <SessionTimeoutMonitor />
      <ProfileProvider>
        <ApplicantMessagesProvider>
          <Routes>
            <Route
              path="/apply/:caseId/:sectionName"
              element={<Application />}
            />
            <Route
              path="/apply/:caseId/submitted"
              element={<ApplicationSubmitted />}
            />
            <Route path="/apply/:caseId/*" element={<Application />} />
            <Route path="/report/:caseId" element={<ReportPage />} />
            <Route
              path="/monitoring/:customerAccountId"
              element={<MonitoringClientDetailPage />}
            />
            <Route
              path="/:caseId/dco-review"
              element={<DCOReviewDecisionPage />}
            />
            <Route
              path="/:caseId/information-request"
              element={<InformationRequestPage />}
            />
            <Route path="*" element={<AppRoutes />} />
          </Routes>
        </ApplicantMessagesProvider>
      </ProfileProvider>
    </AuthOutlet>
  );
}
